import React from "react"
import styled from "@emotion/styled"
import Image from "../global/Image"

import User1 from "../../images/user/user-thumbnail-1.jpg"
import User2 from "../../images/user/user-thumbnail-2.jpg"
import User3 from "../../images/user/user-thumbnail-3.jpg"

import Cursor1 from "../../images/cursors/cursor-1.svg"
import Cursor2 from "../../images/cursors/cursor-2.svg"
import Cursor3 from "../../images/cursors/cursor-3.svg"

const Outer = styled.section`
  display: grid;
  grid-template-columns:
    minmax(32px, auto) minmax(auto, ${props => props.theme.maxWidth})
    minmax(32px, auto);
  padding: 160px 0;
  background: ${props => props.theme.shade[90]};
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    grid-template-columns: 24px auto 24px;
  }
`
const Inner = styled.div`
  grid-column: 2;
  text-align: center;
`

const Cursor = styled.img`
  width: 40px;
  position: absolute;
  bottom: 10%;
  left: 60%;
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    width: 20px;
  }
  &:nth-of-type(2) {
    animation-delay: -3s;
    top: 50%;
    left: 30%;
  }
  &:nth-of-type(3) {
    animation-delay: -7s;
    top: 20%;
    left: 70%;
  }
`
const User = styled.img`
  width: 120px;
  height: 120px;
  border-radius: 16px;
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    width: 80px;
    height: 80px;
  }
`
const UserGrid = styled.div`
  display: flex;
  justify-content: center;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  position: absolute;
  top: -40px;
  left: 0;
  right: 0;
  margin: auto;
`

const Wireframe = styled.div`
  border-radius: 16px;
  width: 100%;
`

const WireframeContainer = styled.div`
  position: relative;
  box-shadow: 0 30px 60px -12px rgba(50, 50, 93, 0.25),
    0 18px 36px -18px rgba(0, 0, 0, 0.1);
  border-radius: 32px;
  position: relative;
`
const Subtitle = styled.h2`
  margin-top: 64px;
  font-size: 2rem;
  max-width: 640px;
  margin-left: auto;
  margin-right: auto;
`

export default function AnimatedHero() {
  return (
    <Outer>
      <Inner>
        <Wireframe>
          <WireframeContainer>
            <Image src="johnlewis" alt="Basecamp Screenshot" />
            <Cursor src={Cursor1} alt="A mouse cursor" />
            <Cursor src={Cursor2} alt="A mouse cursor" />
            <Cursor src={Cursor3} alt="A mouse cursor" />
            <UserGrid>
              <User src={User1} alt="A user testing user" />
              <User src={User2} alt="A user testing user" />
              <User src={User3} alt="A user testing user" />
            </UserGrid>
          </WireframeContainer>
        </Wireframe>
        <Subtitle>
          Don’t let fixable UX issues lose you customers and money
        </Subtitle>
      </Inner>
    </Outer>
  )
}
